import { Descriptions } from "antd";
import dayjs from "dayjs";

export const OrderOverview = ({ order }: any) => {
  return (
    <>
      <Descriptions title="Overview" bordered size="small" column={2}>
        <Descriptions.Item label="Order No">
          <span className="font-bold">{order.order_no}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Date & Time">
          {dayjs(order.order_date).format("YYYY-MM-DD HH:mm")}
        </Descriptions.Item>
        <Descriptions.Item label="Customer">
          {order.customer_name || "Walk-in Customer"}
        </Descriptions.Item>
        <Descriptions.Item label="Table">
          {order.table_name || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Employee">
          {order.employee_name || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Store">{order.store_name}</Descriptions.Item>
        <Descriptions.Item label="Selling Type">
          <span className="capitalize">{order.selling_type}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Cashier User">
          {order.username}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
